import { Typography } from "antd";
import { useTranslation } from "react-i18next";

import ApiDocLink from "@/modules/api-doc-link";
import { useGetApiVersion } from "@/services/api";

const { Title, Text } = Typography;

const ApiVersion = () => {
  const { t } = useTranslation();
  const { apiVersion } = useGetApiVersion();

  if (!apiVersion) return null;

  return (
    <div className="api-version">
      <Title level={4}>{t("global:apiVersion")}</Title>
      <Text>
        <ApiDocLink>{apiVersion}</ApiDocLink>
      </Text>
    </div>
  );
};

export default ApiVersion;
